/* call cp_cookieBanner.init('your_language'); after script tag with cp_cookie_banner.js*/

var cp_cookieBanner = cp_cookieBanner || {};

(function (obj) {
    obj.options = {
        cp_mainClass: 'cp-bot-msg',
        cp_styles: '.cp-bot-msg{position:fixed;bottom:0;left:0;width:100%;z-index:1000;display:none}.cp-bot-msg.show{display:block}.cp-bot-msg div{box-sizing:border-box;}.cp-bot-msg__content{width:100%;background-color:#fff;border-radius:0;box-shadow:0 0 10px rgba(0,0,0,.4);border:1px solid #8c8c8c;position:relative;padding:20px;font-size:12px;display:table}.cp-bot-msg__text{display:table-cell;padding-right:30px;vertical-align:middle;font-size: 14px;font-weight:normal;}.cp-bot-msg__right{display:table-cell;vertical-align:middle;text-align:center}.cp-bot-msg__close{font-size:16px;font-weight:700;width:100px;border-radius:3px;text-align:center;color:#fff;padding:5px;background-color:#bdbdbd;display:inline-block}.cp-bot-msg__close:hover{cursor:pointer}',
        cp_message_rus: 'На данном сайте собираются метаданные пользователя (cookies, данные об IP-адресе и местоположении) с целью накопления статистической информации для анализа и улучшения работы сайта. Если Вы не согласны с обработкой вышеуказанных метаданных, то Вам необходимо покинуть этот сайт',
        cp_message_eng: 'This website gathers users’ metadata (cookies, IP address and location). This is used to collect statistical information for analysis and improve our website. By continuing to use our website you agree to our use of cookies',
        cp_close_text: 'OK'
    }

    obj.init = function (lang) {
        /* Render banner */
        var cp_stylesTag = document.createElement('style');
        document.body.appendChild(cp_stylesTag);
        cp_stylesTag.textContent = obj.options.cp_styles;

        var cp_banner = document.createElement('div');
        cp_banner.className += 'cp-bot-msg';
        cp_banner.className += ' js-cp-bot-msg';
        var cp_bannerContent = document.createElement('div');
        cp_bannerContent.className += 'cp-bot-msg__content';
        var cp_bannerContentText = document.createElement('div');
        cp_bannerContentText.className += 'cp-bot-msg__text';
        var cp_bannerContentRight = document.createElement('div');
        cp_bannerContentRight.className += 'cp-bot-msg__right';
        var cp_bannerContentClose = document.createElement('div');
        cp_bannerContentClose.className += 'cp-bot-msg__close';
        cp_bannerContentClose.className += ' js-close-msg';

        document.body.appendChild(cp_banner);
        cp_banner.appendChild(cp_bannerContent);
        cp_bannerContent.appendChild(cp_bannerContentText);
        cp_bannerContent.appendChild(cp_bannerContentRight);
        cp_bannerContentRight.appendChild(cp_bannerContentClose);
        var cp_txt = '';
        if (lang !== undefined) {
            if (lang === 'rus') {
                cp_txt = this.options.cp_message_rus;
            }
            if (lang === 'eng') {
                cp_txt = this.options.cp_message_eng;
            }
        } else {
            cp_txt = this.options.cp_message_eng
        }

        cp_bannerContentText.textContent = cp_txt;
        cp_bannerContentClose.textContent = this.options.cp_close_text;

        /* work with cookies */
        var cp_cookie = {
            // cookie name
            cookieName: 'pview',
            // popup
            popup: cp_banner,
            // write cookie
            fn_cSet: function createCookie(name, value, days) {
                if (days) {
                    var date = new Date();
                    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                    var expires = "; expires=" + date.toGMTString();
                } else var expires = "";
                document.cookie = name + "=" + value + expires + "; path=/";
            },
            // read cookie
            fn_cRead: function readCookie(name) {
                var nameEQ = name + "=";
                var ca = document.cookie.split(';');
                for (var i = 0; i < ca.length; i++) {
                    var c = ca[i];
                    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
                    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
                }
                return null;
            }
        }

        /* popup bottom */
        var cp_botMsg = {
            // popup element
            bPop: cp_banner,
            // open popup
            bPopOpen: function fn_bPopOpen() {
                this.bPop.className = obj.options.cp_mainClass + ' show';
            },
            // close popup
            bPopClose: function fn_bPopClose() {
                this.bPop.className = obj.options.cp_mainClass;
            }
        }

        // open popup, if first time
        if (cp_cookie.fn_cRead(cp_cookie.cookieName) != 1) {
            cp_botMsg.bPopOpen();
        }

        // close popup, set cookiev
        var cp_close = cp_bannerContentClose;
        cp_close.onclick = function () {
            cp_banner.classList.remove('show');
            cp_cookie.fn_cSet(cp_cookie.cookieName, 1, 365);
        };
    }
})(cp_cookieBanner);